import { GET_ABOUT_US_ERROR, GET_ABOUT_US_START, GET_ABOUT_US_SUCCESS } from '../../types';

export default function get_about_us(state, action) {
  switch (action.type) {
    case GET_ABOUT_US_START:
      return { ...state };
    case GET_ABOUT_US_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case GET_ABOUT_US_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
